let isLocal = process.env.NODE_ENV === 'development';
isLocal = false;
export default {
    isLocal: isLocal,
    apiAuthOff: true,
    host: isLocal ? 'http://localhost:3050' : location.origin,
    colors: ['#e6194b', '#3cb44b', '#ffe119', '#4363d8', '#f58231', '#911eb4', '#46f0f0', '#f032e6', '#bcf60c', '#fabebe', '#008080', '#e6beff', '#9a6324', '#fffac8', '#800000', '#aaffc3', '#808000', '#ffd8b1', '#000075', '#808080'],
    colorsByName: {
        red: '#e6194b',
        green: '#3cb44b',
        yellow: '#ffe119',
        blue: '#4363d8',
    },
}
 